import { globalTypes } from "reducers/types/global";

export const types = {
    LIST_DIRECT_DEBIT_REQUEST: "directDebit/LIST_DIRECT_DEBIT_REQUEST",
    LIST_DIRECT_DEBIT_SUCCESS: "directDebit/LIST_DIRECT_DEBIT_SUCCESS",
    LIST_DIRECT_DEBIT_FAILURE: "directDebit/LIST_DIRECT_DEBIT_FAILURE",
    DIRECT_DEBIT_CREATE_PRE_REQUEST: "directDebit/DIRECT_DEBIT_CREATE_PRE_REQUEST",
    DIRECT_DEBIT_CREATE_PRE_SUCCESS: "directDebit/DIRECT_DEBIT_CREATE_PRE_SUCCESS",
    DIRECT_DEBIT_CREATE_PRE_FAILURE: "directDebit/DIRECT_DEBIT_CREATE_PRE_FAILURE",
    DIRECT_DEBIT_PREVIEW_REQUEST: "directDebit/DIRECT_DEBIT_PREVIEW_REQUEST",
    DIRECT_DEBIT_PREVIEW_SUCCESS: "directDebit/DIRECT_DEBIT_PREVIEW_SUCCESS",
    DIRECT_DEBIT_PREVIEW_FAILURE: "directDebit/DIRECT_DEBIT_PREVIEW_FAILURE",
    DIRECT_DEBIT_SEND_REQUEST: "directDebit/DIRECT_DEBIT_SEND_REQUEST",
    DIRECT_DEBIT_SEND_SUCCESS: "directDebit/DIRECT_DEBIT_SEND_SUCCESS",
    DIRECT_DEBIT_SEND_FAILURE: "directDebit/DIRECT_DEBIT_SEND_FAILURE",
    DIRECT_DEBIT_CLEAN_DATA: "directDebit/DIRECT_DEBIT_CLEAN_DATA",
    DIRECT_DEBIT_TRANSACTION_SET_DATA: "directDebit/DIRECT_DEBIT_TRANSACTION_SET_DATA",
    GO_BACK_DIRECT_DEBIT: "directDebit/GO_BACK_DIRECT_DEBIT",
    DOWNLOAD_DETAIL_FILE_REQUEST: "directDebit/DOWNLOAD_DETAIL_FILE_REQUEST",
    DOWNLOAD_DETAIL_FILE_SUCCESS: "directDebit/DOWNLOAD_DETAIL_FILE_SUCCESS",
    DOWNLOAD_DETAIL_FILE_FAILURE: "directDebit/DOWNLOAD_DETAIL_FILE_FAILURE",
};

export const INITIAL_STATE = {
    fetchingList: false,
    listDirectDebit: [],
    totalPages: 0,
    pageNumber: 0,
    initialValues: null,
    transactionData: null,
    goBackDirectDebit: false,
    dateUpload: null,
    fetchingDownload: false,
    accounts: [],
    fetchingAccounts: false,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        listDirectDebit,
        totalPages,
        pageNumber,
        payrollOptions,
        accounts,
        initialValues,
        transactionData,
        goBackDirectDebit,
        dateUpload,
        isDesktop,
    } = action;
    switch (action.type) {
        case types.LIST_DIRECT_DEBIT_REQUEST:
            return { ...state, fetchingList: true };
        case types.LIST_DIRECT_DEBIT_SUCCESS:
            return {
                ...state,
                fetchingList: false,
                listDirectDebit:
                    isDesktop || pageNumber === 1 ? listDirectDebit : [...state.listDirectDebit, ...listDirectDebit],
                totalPages,
                pageNumber,
            };
        case types.LIST_DIRECT_DEBIT_FAILURE:
            return { ...INITIAL_STATE };
        case types.DIRECT_DEBIT_CREATE_PRE_REQUEST:
            return { ...state, fetchingList: true, fetchingAccounts: true };
        case types.DIRECT_DEBIT_CREATE_PRE_SUCCESS:
            return { ...state, fetchingList: false, fetchingAccounts: false, payrollOptions, accounts };
        case types.DIRECT_DEBIT_CREATE_PRE_FAILURE:
            return { ...INITIAL_STATE };
        case types.DIRECT_DEBIT_PREVIEW_REQUEST:
            return { ...state, fetchingList: true };
        case types.DIRECT_DEBIT_PREVIEW_SUCCESS:
            return { ...state, fetchingList: false, initialValues, dateUpload };
        case types.DIRECT_DEBIT_PREVIEW_FAILURE:
            return { ...state, fetchingList: false };
        case globalTypes.RESET_SELECTED_ELEMENTS:
        case types.DIRECT_DEBIT_CLEAN_DATA:
            return { ...INITIAL_STATE };
        case types.DIRECT_DEBIT_SEND_REQUEST:
            return { ...state, fetchingList: true };
        case types.DIRECT_DEBIT_SEND_SUCCESS:
            return { ...state, initialValues: null, fetchingList: false };
        case types.DIRECT_DEBIT_SEND_FAILURE:
            return { ...state, fetchingList: false };
        case types.DIRECT_DEBIT_TRANSACTION_SET_DATA:
            return { ...state, transactionData };
        case types.DOWNLOAD_DETAIL_FILE_REQUEST:
            return { ...state, fetchingDownload: true };
        case types.DOWNLOAD_DETAIL_FILE_SUCCESS:
            return { ...state, fetchingDownload: false };
        case types.DOWNLOAD_DETAIL_FILE_FAILURE:
            return { ...state, fetchingDownload: false };
        case types.GO_BACK_DIRECT_DEBIT:
            return {
                ...state,
                goBackDirectDebit,
            };
        default:
            return state;
    }
};

export const actions = {
    listDirectDebit: (valuesForm, isDesktop) => ({
        type: types.LIST_DIRECT_DEBIT_REQUEST,
        valuesForm,
        isDesktop,
    }),
    directDebitCreatePre: () => ({
        type: types.DIRECT_DEBIT_CREATE_PRE_REQUEST,
    }),
    directDebitPreviewRequest: (valuesForm) => ({
        type: types.DIRECT_DEBIT_PREVIEW_REQUEST,
        valuesForm,
    }),
    directDebitCleanData: () => ({
        type: types.DIRECT_DEBIT_CLEAN_DATA,
    }),
    directDebitSend: (valuesForm) => ({
        type: types.DIRECT_DEBIT_SEND_REQUEST,
        valuesForm,
    }),
    directDebitTransactionSetData: (transactionData) => ({
        type: types.DIRECT_DEBIT_TRANSACTION_SET_DATA,
        transactionData,
    }),
    setGoBackDirectDebit: (goBackDirectDebit) => ({
        type: types.GO_BACK_DIRECT_DEBIT,
        goBackDirectDebit,
    }),
    downloadDirectDebitDetailFile: (format, idTransaction) => ({
        type: types.DOWNLOAD_DETAIL_FILE_REQUEST,
        format,
        idTransaction,
    }),
};

export const selectors = {
    getFetchingList: ({ directDebit }) => directDebit.fetchingList,
    getFetchingAccounts: ({ directDebit }) => directDebit.fetchingAccounts,
    getDirectDebitList: ({ directDebit }) => directDebit.listDirectDebit,
    getTotalPages: ({ directDebit }) => directDebit.totalPages,
    getPageNumber: ({ directDebit }) => directDebit.pageNumber,
    getPayrollOptions: ({ directDebit }) => directDebit.payrollOptions,
    getAccounts: ({ directDebit }) => directDebit.accounts,
    getInitialValues: ({ directDebit }) => directDebit.initialValues,
    getDirectDebitTransactionData: ({ directDebit }) => directDebit.transactionData,
    isGoBackDirectDebit: ({ directDebit }) => directDebit.goBackDirectDebit,
    getDateUpload: ({ directDebit }) => directDebit.dateUpload,
    getFetchingDownload: ({ directDebit }) => directDebit.fetchingDownload,
};
